import * as db from './db';
export type Type = {
  readonly db: db.Scope;
};
export { db };
